var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAzureKeyvaultSecret(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75189 4.41725H6.99603V5.70891H5.75189V4.41725Z",
    fill: "#60C5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24017 4.41725H9.48431V5.70891H8.24017V4.41725Z",
    fill: "#60C5E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7284 4.41725H11.9726V5.70891H10.7284V4.41725Z",
    fill: "#60C5E7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2167 4.41725H14.4609V5.70891H13.2167V4.41725Z",
    fill: "#60C5E7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75189 7.00057H6.99603V8.29223H5.75189V7.00057Z",
    fill: "#60C5E7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24017 7.00057H9.48431V8.29223H8.24017V7.00057Z",
    fill: "#60C5E7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7284 7.00057H11.9726V8.29223H10.7284V7.00057Z",
    fill: "#60C5E7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2167 7.00057H14.4609V8.29223H13.2167V7.00057Z",
    fill: "#60C5E7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75189 9.58389H6.99603V10.8756H5.75189V9.58389Z",
    fill: "#60C5E7"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24017 9.58389H9.48431V10.8756H8.24017V9.58389Z",
    fill: "#60C5E7"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7284 9.58389H11.9726V10.8756H10.7284V9.58389Z",
    fill: "#60C5E7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2167 9.58389H14.4609V10.8756H13.2167V9.58389Z",
    fill: "#60C5E7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75189 12.1672H6.99603V13.4589H5.75189V12.1672Z",
    fill: "#60C5E7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24017 12.1672H9.48431V13.4589H8.24017V12.1672Z",
    fill: "#60C5E7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7284 12.1672H11.9726V13.4589H10.7284V12.1672Z",
    fill: "#60C5E7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2167 12.1672H14.4609V13.4589H13.2167V12.1672Z",
    fill: "#60C5E7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7594 2.29166H3.45337V19.1118H16.7594V2.29166ZM2.20923 1V20.4035H18.0035V1H2.20923Z",
    fill: "#009ACB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3958 14.2948H11.1598C10.2437 14.2948 9.50096 15.0658 9.50096 16.017V21.2778C9.50096 22.2289 10.2437 23 11.1598 23H20.1319C21.0481 23 21.7908 22.2289 21.7908 21.2778V16.017C21.7908 15.0658 21.0481 14.2948 20.1319 14.2948H19.9086C20.0218 11.3984 19.0101 8.20057 15.5447 8.20057C11.8981 8.20057 11.2388 11.9428 11.3958 14.2948ZM17.8718 14.2948C18.033 12.3594 17.7425 10.2597 15.588 10.2597C13.2629 10.2597 13.1849 12.976 13.439 14.2945L17.8718 14.2948Z",
    fill: "#FFB900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureKeyvaultSecret);
export default __webpack_public_path__ + "static/media/azure_keyvault_secret.f52e2e684d2223c2ef983fac1a1948d0.svg";
export { ForwardRef as ReactComponent };